import { CALL_API, Schemas } from '../../common/middleware/api';
import globalize from '../../common/services/globalize';
import moment from 'moment';

export const INSTALMENT_PAYMENTS_REQUEST = 'INSTALMENT_PAYMENTS_REQUEST';
export const INSTALMENT_PAYMENTS_SUCCESS = 'INSTALMENT_PAYMENTS_SUCCESS';
export const INSTALMENT_PAYMENTS_FAILURE = 'INSTALMENT_PAYMENTS_FAILURE';

export const INSTALMENT_PAYMENTS_EXPORT_REQUEST = 'INSTALMENT_PAYMENTS_EXPORT_REQUEST';
export const INSTALMENT_PAYMENTS_EXPORT_SUCCESS = 'INSTALMENT_PAYMENTS_EXPORT_SUCCESS';
export const INSTALMENT_PAYMENTS_EXPORT_FAILURE = 'INSTALMENT_PAYMENTS_EXPORT_FAILURE';

export const PAYMENTS_REQUEST = 'PAYMENTS_REQUEST';
export const PAYMENTS_SUCCESS = 'PAYMENTS_SUCCESS';
export const PAYMENTS_FAILURE = 'PAYMENTS_FAILURE';

export const PAYMENTS_EXPORT_REQUEST = 'PAYMENTS_EXPORT_REQUEST';
export const PAYMENTS_EXPORT_SUCCESS = 'PAYMENTS_EXPORT_SUCCESS';
export const PAYMENTS_EXPORT_FAILURE = 'PAYMENTS_EXPORT_FAILURE';

export const INSTALMENT_PAYMENT_MARK_AS_PAID_REQUEST = 'INSTALMENT_PAYMENT_MARK_AS_PAID_REQUEST';
export const INSTALMENT_PAYMENT_MARK_AS_PAID_SUCCESS = 'INSTALMENT_PAYMENT_MARK_AS_PAID_SUCCESS';
export const INSTALMENT_PAYMENT_MARK_AS_PAID_FAILURE = 'INSTALMENT_PAYMENT_MARK_AS_PAID_FAILURE';

export const loadInstalmentPayments = (options) => ({
	[CALL_API]: {
		types: [INSTALMENT_PAYMENTS_REQUEST, INSTALMENT_PAYMENTS_SUCCESS, INSTALMENT_PAYMENTS_FAILURE],
		endpoint: 'api/instalmentPayments',
		request: options,
		schema: Schemas.INSTALMENT_PAYMENT_ARRAY
	}
});

export const exportInstalmentPayments = (exportFormat, options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [INSTALMENT_PAYMENTS_EXPORT_REQUEST, INSTALMENT_PAYMENTS_EXPORT_SUCCESS, INSTALMENT_PAYMENTS_EXPORT_FAILURE],
			endpoint: `api/instalmentPayments/export/${exportFormat === 'Xero' ? 'xero' : ''}`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: exportFormat,
		filename: () => `InstalmentPaymentReport-${moment().format('YYYY-MM-DD')}.${exportFormat === 'Xero' ? 'csv' : 'xlsx'}`
	});
}

export const loadPayments = (options) => ({
	[CALL_API]: {
		types: [PAYMENTS_REQUEST, PAYMENTS_SUCCESS, PAYMENTS_FAILURE],
		endpoint: 'api/paymentHistory',
		request: options,
		schema: Schemas.PAYMENTS_ARRAY
	}
});

export const exportPayments = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [PAYMENTS_EXPORT_REQUEST, PAYMENTS_EXPORT_SUCCESS, PAYMENTS_EXPORT_FAILURE],
			endpoint: `api/paymentHistory/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `Payments-${moment().format('YYYY-MM-DD')}.xlsx`
	});
}

export const markAsPaidInstalment = (id, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [INSTALMENT_PAYMENT_MARK_AS_PAID_REQUEST, INSTALMENT_PAYMENT_MARK_AS_PAID_SUCCESS, INSTALMENT_PAYMENT_MARK_AS_PAID_FAILURE],
		endpoint: `api/instalmentPayments/${id}/markAsPaid`,
		method: 'PUT',
		request: options,
		schema: Schemas.PAYMENT_HISTORY,
		form: 'markAsPaidInstalment',
		onSuccessEvent
	}
});